// extracted by mini-css-extract-plugin
module.exports = {"grey_dark":"#8A93A6","rehab-team__container":"style_rehab-team__container__G9Lt0","rehab-team__subtitle":"style_rehab-team__subtitle__30xjr","nodata":"style_nodata__Gc5jL"};